/**
 * 真人出镜页提交失败的人话(0924 车 D 一期止血)。
 *
 * ★为什么要单独一层:这些错误都是**确定性**的(再点一次还是同样结果),通用桶那句
 *   「请稍后重试」对它们是错话 —— 0919 老板那两单超时长就是被它骗着连点了两次。
 *   也不能再让用户「走分身舱」:人就在真人出镜页,真人出镜本身就是正确的路。
 * 错误码与 D-api / D-ai 同批对齐(契约 §3.4):
 *   SWAP_DURATION_EXCEEDS_TIER          api 422:参考视频超所选档时长
 *   (D-api 实现:超档与 >30s **共用这一个码**,只靠消息区分 —— 这里一句人话把三档讲全)
 *   REAL_PERSON_CAST_EMPTY              api 422:文案出片出镜人物解不出(0920 TaskTypeConstraint 那单)
 *   VIDEO_SWAP_REQUIRES_REAL_PERSON     api 老码:换我出镜人物为空(D-api 保留老码,同一句人话)
 *   COPY_WITH_REAL_PERSON_UNSUPPORTED   ai:照原片仿拍 × 真人人物
 *   VENDOR_ASSET_REJECTED / 文本含「参考视频含真人」 上游拒参考视频
 */
import { ApiError } from "@/shared/api";
import { errorText } from "@/shared/lib/apiErrors";

export const REAL_PERSON_ERROR_CODES = {
  swapDurationExceedsTier: "SWAP_DURATION_EXCEEDS_TIER",
  castEmpty: "REAL_PERSON_CAST_EMPTY",
  swapRequiresRealPerson: "VIDEO_SWAP_REQUIRES_REAL_PERSON",
  copyWithRealPerson: "COPY_WITH_REAL_PERSON_UNSUPPORTED",
  vendorAssetRejected: "VENDOR_ASSET_REJECTED",
} as const;

/** 与 ai `COPY_WITH_REAL_PERSON_UNSUPPORTED` 人话逐字同源(D-ai 任务书原话)。 */
export const COPY_WITH_REAL_PERSON_TEXT = "照原片仿拍不支持本人出镜,切『只学套路』或去真人出镜页";

export const SWAP_DURATION_EXCEEDS_TEXT =
  "参考视频超过所选档位的时长:15 秒以内任意档都行;15~30 秒请切到「旗舰」档(可拍到 30 秒);超过 30 秒请用手机重新拍一段更短的原件(别剪辑、别转码)。这单没有提交,不扣费。";

export const CAST_EMPTY_TEXT =
  "没认出这单的出镜人 —— 请在「谁来出镜」重新点选一位已授权的出镜人再出片。这单没有提交,不扣费。";

export const REF_HAS_REAL_PERSON_TEXT =
  "参考视频被上游审核拒了(画面里有真人/写实人物,或是转发下载来的视频)。换一段你本人用手机直接拍的原件再试,别用微信转发件或别人的视频;被拒不扣费。";

function codeOf(e: unknown): string | null {
  return e instanceof ApiError ? e.errorCode : null;
}

export function realPersonSubmitErrorText(e: unknown): string {
  const code = codeOf(e);
  const msg = e instanceof Error ? e.message : "";
  if (code === REAL_PERSON_ERROR_CODES.swapDurationExceedsTier) return SWAP_DURATION_EXCEEDS_TEXT;
  if (
    code === REAL_PERSON_ERROR_CODES.castEmpty ||
    code === REAL_PERSON_ERROR_CODES.swapRequiresRealPerson
  ) {
    return CAST_EMPTY_TEXT;
  }
  if (code === REAL_PERSON_ERROR_CODES.copyWithRealPerson) return COPY_WITH_REAL_PERSON_TEXT;
  if (code === REAL_PERSON_ERROR_CODES.vendorAssetRejected || /参考视频含真人/.test(msg)) {
    return REF_HAS_REAL_PERSON_TEXT;
  }
  return errorText(e, { hiddenDescription: "提交失败,请重试" });
}
